import { useEffect, useState } from "react";
import { Button } from "../components/Button";
import { TextField } from "../components/TextField";
import css from "./../styles/invoice.css";
import ReactPDF from '@react-pdf/renderer';
import { Form, Link, useLoaderData } from "react-router-dom";
import { formatDate, getUserId } from "../services/helpers";
import { pdf } from "@react-pdf/renderer";
import mixpanel from "../services/mixpanel";

export function ServiceInvoice() {
	const loaderData = useLoaderData();
	const services = loaderData.service_ticket.details;
	const customerDetails = loaderData.customer_details.customer_details;
	const [invoiceTotal,setInvoiceTotal] = useState(0);
	const [currency,setCurrency] = useState("GHS");
	const [amountPaid,setAmountPaid] = useState(0);
	const [discount,setDiscount] = useState(0);
	const [dateUpdated,setDateUpdated] = useState(null);

	async function send_invoice(){
		// let invoiceHtml = document.getElementById("preview").innerHTML;
		// let response = await fetch('/api/index.php/send_invoice', {
		// 	method: 'POST',
		// 	headers: { 'Content-Type': 'application/json' },
		// 	body: JSON.stringify({ invoice: invoiceHtml })
		//   });

		//   console.log(await response.text());
	}


	useEffect(()=>{
		mixpanel.identify(getUserId());
		let base = services[0];
		setCurrency(base.currency);
		setDateUpdated(base.date_updated)
		services.map((service)=>{
			setInvoiceTotal((prev)=> prev+service.price);
		})

	},[]);


	function RenderPreview(){
		return <div id="preview">

				<div className="banner">
					<img src="https://fitaautotech.com/assets/img/logo/FITA_white_logo.png" alt="FITA Logo" />
					<h3>Join Africa's fastest-growing vehicle membership community with FITA today</h3>
				</div>


				<div className="invoice-container">
					<section className="header">
						<h1>Proforma Invoice</h1>
					</section>

					<section className="details">

						<div className="addresses">

							<div id="customer-details">
								<p className="fs-12">BILL TO </p>
								<p>{`${customerDetails.first_name} ${customerDetails.last_name}`}</p>
								<p>{`${customerDetails.email}`}</p>
								<p>{`${customerDetails.phone_number}`}</p>
							</div>

							<div className="fita-details">
								<p></p>
								<p className="black">FITA Autotech</p>
								<p>Spintex Road - JP Fuel Station</p>
								<p>Accra</p>
								<p>+233257143312</p>
							</div>
						</div>

						<div className="invoice-summary">
							<div>
								<h2>FITA Autotech Repair Order</h2>
								<p><strong>Invoice #</strong> {services[0].ticket_id}</p>
								<p>{formatDate(dateUpdated)}</p>
							</div>
							<div id="amount-summary">
								<h2>GHS {(invoiceTotal *(1- (discount/100)))-amountPaid}</h2>
								<p>Total Amount</p>
							</div>
						</div>

					</section>

					<table className="table" id="task-table">
						<thead>
							<tr>
								<th>Item</th>
								<th>Price</th>
							</tr>
						</thead>
						<tbody>
							{services.map((service)=>{
								return (
							<tr key={service.service_item_id}>
								<td>
									<p>{service.item_name}</p>
									{service.description != "" && <p>{service.description}</p>}
									</td>
								<td><p>{`${service.currency} ${service.price}`}</p></td>
							</tr>
								);
							})}
						</tbody>
					</table>
					{/* <table className="table" id="invoice-table">

						<thead>
							<tr>
								<th>Item</th>
								<th>Qty</th>
								<th>Unit Price</th>
								<th>Total</th>
							</tr>
						</thead>
						<tbody>
							{services.map((service)=>{
								console.log("service",service);
								return (<tr>
								<td>
									<p>{service.item_name}</p>
									{service.description !="" && <p className="note">{service.description}</p>}
								</td>
								<td>
									<p>2</p>
								</td>
								<td>
									<p>GHS {service.price}</p>
								</td>
								<td>
									<p>GHS 1200.00</p>
								</td>
							</tr>)

							})}
						</tbody>
					</table> */}

					<section className="terms-section">
						<div className="payment-details">
							Notes
							<p>Full Payment to be made to Bank or Momo:</p>
							<p className="label">Bank Account Details</p>
							<p>GREEN HOPPER LTD CEDI ACCOUNT</p>
							<p><span className="info-label">ACCOUNT NAME:</span> Green Hopper Ltd</p>
							<p><span className="info-label">ACCOUNT NUMBER:</span> 6110101184</p>
							<p><span className="info-label">BANK NAME:</span> Zenith Bank Ltd</p>
							<p><span className="info-label">BANK BRANCH:</span> Head Office, Independence Avenue, Accra</p>
							<p><span className="info-label">SWIFT CODE:</span> ZEBLGHAC</p>

							<p className="label">Momo Details</p>
							<p><span className="info-label">MOMO NAME:</span> GREEN HOPPER LTD</p>
							<p><span className="info-label">MOMO NUMBER:</span> 0599002528</p>
							<p><span className="info-label">MOMO PAY ID:</span> 013959</p>
						</div>
						<div className="summary">

							<table className="table" id="summary-table">
								<tbody>
									<tr>
										<td>
											<p>Subtotal</p>
											<p className="note">Discount {`(${discount}%)`}</p>
										</td>
										<td>
											<p>{`${currency} ${invoiceTotal}`}</p>
											<p className="note">{`${currency} ${(invoiceTotal*discount/100)}`}</p>
										</td>

									</tr>
									<tr>
										<td>
											<p>Total</p>
											<p className="note">Paid</p>
										</td>
										<td>
											<p>{`${currency} ${invoiceTotal - (invoiceTotal*discount/100)}`}</p>
											<p className="note">{`(${currency} ${amountPaid})`}</p>
										</td>
									</tr>
									<tr id="amount-due">
										<td>
											<p>Amount Due</p>
										</td>
										<td>
											<p>{`${currency} ${(invoiceTotal *(1- (discount/100)))-amountPaid}`}</p>
										</td>
									</tr>
								</tbody>
							</table>
							<div className="accept-button">
								<button>Accept Invoice</button>
							</div>

						</div>
					</section>
				</div>
			</div>
	}
	return <main>
		<h1>Service Invoice</h1>
		<Link to="/dashboard/services">Back to Service Ticket</Link>
		<div id="page-detail-card">
			<div id="header-section">
				<div id="header-image">
					<img src="https://avatar.iran.liara.run/public/43" alt="" />
				</div>
				<div id="middle">
					<h3>Customer name here</h3>
					<p>Vehicle Make (2000)</p>
					<p>GR XXX ER</p>
				</div>
				<div id="end">
					<Form action="">
						<h3>Kelvin Smith</h3>
						<TextField
							label="email"
						/>
						<Button
							label="Send Invoice"
							color="black"
							onClick={() => {
								send_invoice();
							 }}
						/>
					</Form>
				</div>
			</div>

			{/* {RenderPreview()} */}
			{/* {ReactPDF.} */}
			<RenderPreview />
		</div>





	</main>
}


function InvoiceRender(){

}